const styles = (theme) => ({
  categoryName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    }
  },
  categoryItemsCount: {
    color: 'rgba(15, 23, 42, 0.60)',
    fontSize: 12,
  },
  categoryTotal: {
    fontSize: 12,
  }
});

export default styles;